import {RouteStop} from "../../../api/Logistics";
import {EditAddressTemplate} from "../../settings/companies/clients/client/EditAddressTemplate";


export function AddressManageCustom(props: {
    value: RouteStop;
    onClose(): void;
    onUpdate(value: RouteStop): Promise<any>;
}) {

    return (
        <EditAddressTemplate
            title="Edit Address"
            street={props.value.addressStreet || ""}
            city={props.value.addressCity || ""}
            postal={props.value.addressPostal || ""}
            onClose={props.onClose}
            onUpdate={input => {
                return props.onUpdate(Object.assign({}, props.value, {
                    customTextStopAddressStreet: input.street,
                    customTextStopAddressCity: input.city,
                    customTextStopAddressPostal: input.postal,
                }))
            }}
        />
    )
}